<template>
    <div v-bind:class="$style.container">
        <MainLogo />

        <div v-if="mq_isMediumPlus" v-bind:class="$style.links">
            <div
                v-bind:class="$style.link"
            >
                <VTooltip left light>
                    <template slot="activator">
                        <a href="https://chrome.google.com/webstore/detail/citizenj-comment-on-any-w/lgcapmfoacjdejiahggcolllphnpgbcb">
                            <AppIcon
                                name="download"
                                title="Download extension"
                                alt="Download extension"
                            />
                        </a>
                    </template>
                    Download <span v-if="mq_isLargePlus">Chrome</span> Extension</b>
                </VTooltip>
            </div>
            <div
                v-if="!isSearchExpanded"
                v-bind:class="$style.link"
                v-on:click="openSearch"
            >
                <AppIcon
                    name="search"
                    title="Search Citizen J."
                    alt="Search"
                />
            </div>
            <template v-if="!isAuthenticated">
                <RouterLink
                    v-bind:to="{
                        name: 'login',
                    }"
                    v-bind:class="$style.link"
                >
                    Login
                </RouterLink>
                <VBtn
                    v-bind:to="{
                        name: 'signup',
                    }"
                    depressed
                >
                    Signup
                </VBtn>
            </template>
            <template v-else>
                <img
                    v-if="$store.getters['user/model'].image"
                    v-bind:class="$style.profileThumb"
                    v-bind:src="$store.getters['user/model'].image"
                >
                <RouterLink
                    v-bind:to="{
                        name: 'profile',
                    }"
                    rel="nofollow"
                    v-bind:class="$style.link"
                >
                    Profile
                </RouterLink>
            </template>
        </div>

        <div v-else>
            <button
                v-if="!isSearchExpanded"
                v-bind:class="$style.mobileButton"
                v-on:click="openSearch"
            >
                <AppIcon
                    name="search"
                    title="Search Citizen J."
                    alt="Search"
                    color="white"
                    v-bind:class="$style.mobileSearchIcon"
                />
            </button>
            <button
                v-bind:class="[
                    {
                        [$style.closeIcon]: hasExpandedMobileMenu,
                    },
                    $style.mobileButton,
                ]"
                v-on:click.prevent="toggleMobileMenu"
            >
                <AppIcon
                    color="white"
                    v-bind:name="hasExpandedMobileMenu ? ['fal', 'times'] : ['fa', 'bars']"
                    v-bind:class="{
                        [$style.hamburgerIcon]: !hasExpandedMobileMenu,
                        [$style.closeIcon]: hasExpandedMobileMenu,
                    }"
                    v-bind:transform="hasExpandedMobileMenu ? 'right-1' : ''"
                />
            </button>
        </div>
    </div>
</template>

<script>
    import MediaQueries from '@mixins/MediaQueries';
    import MainLogo from '@components/MainLogo';

    export default {
        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            MainLogo,
        },

        /**
         * Mixins are a flexible way to distribute reusable functionalities for Vue components.
         * A mixin object can contain any component options. When a component uses a mixin,
         * all options in the mixin will be “mixed” into the component’s own options.
         *
         * @link https://vuejs.org/v2/guide/mixins.html
         */
        mixins: [
            MediaQueries,
        ],

        /**
         * You must define defaults for all Vue models and reactive Vue template data.
         *
         * @link https://vuejs.org/v2/api/#data
         *
         * @return Object Vue model and binding defaults.
         */
        data () {
            return {
                hasExpandedMobileMenu: false,
            };
        },

        /**
         * Cached computed methods for complex logic on the view layer.
         *
         * @link https://vuejs.org/v2/guide/computed.html
         *
         * @type Object The computed functions
         */
        computed: {
            isAuthenticated () {
                return this.$auth.check();
            },

            isSearchExpanded () {
                return this.$store.getters['search/isSearchExpanded'];
            },
        },

        /**
         * Non-cached methods that are used by the Vue instance and template.
         *
         * @type Object ES6 methods
         */
        methods: {
            /**
             * Toggle the tablet search field expanded input.
             */
            openSearch () {
                this.$store.dispatch('search/expand');

                this.isSearchExpanded = true;
            },

            /**
             * Toggles the mobile menu and locks scrolling once the menu is open.
             */
            toggleMobileMenu () {
                this.hasExpandedMobileMenu = !this.hasExpandedMobileMenu;

                // Because the root Vue application begins at the first child div
                // within the body tag, the htmlTag variable will target the HTML tag
                // and then add a overflow style of hidden that disables scrolling
                // once a user opens the mobile menu.
                //
                // The overflow style will return
                // back to it's default state of 'visible' once the user clicks out
                // of mobile menu.
                document.documentElement.style.overflow = document.documentElement.style.overflow === 'hidden' ? 'visible' : 'hidden';
            },
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .container {
        @apply flex;
    }

    .links {
        @apply flex flex-row items-center;

        a {
            @apply text-lg;
        }
    }

    .link {
        @apply flex items-center no-underline p-3 text-gray-400 font-bold cursor-pointer;
    }

    .mobileButton {
        @apply outline-none -mt-px;
    }

    .mobileSearchIcon {
        @apply mr-8;
        font-size: 29px;
        transform: translateY(-3px);
    }

    .hamburgerIcon {
        font-size: 36px;
    }

    .closeIcon {
        font-size: 44px;
        line-height: 10px;
    }

    .profileThumb {
        @apply w-4 h-4;
        object-fit: cover;
    }
</style>
